import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchGroups(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/groups', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchGroup(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/groups/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createGroup(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/groups/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            }) 
        },
        addGroup(ctx, groupData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/groups`, groupData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteGroup(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/groups/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateGroup(ctx, groupData) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/groups/${groupData.id}`, groupData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}